"use client";
export { LazyMotion, domAnimation } from "motion/react";
// export * as m from "motion/react-m";
